import createAxiosInstance from './axiosConfig';
import { Financiamento } from '../shared/model/financiamento';

const { REACT_APP_ESTEIRA_BACK } = process.env;

// Define a instância apontando para o novo controller criado no Spring Boot
const axiosInstance = createAxiosInstance(REACT_APP_ESTEIRA_BACK + '/rest/promotoraFinanciamentoController');

export default class PromotoraFinanciamentoService {
  axios: any;

  constructor() {
    this.axios = axiosInstance;
  }

  async listarFinanciamentosPorPromotora(idPromotora: string | number) {
    return await this.axios.get(`/listarFinanciamentosPorPromotora?idPromotora=${idPromotora}`);
  };

  async incluirAlterarPromotoraFinanciamento(dto: any[], idPromotora: string | number) {
    return await this.axios.post(
      `/incluirAlterarPromotoraFinanciamento?idPromotora=${idPromotora}`,
      dto
    );
  };

}